import { createSelector } from "@reduxjs/toolkit";
import { IUserProfile } from "../../../../models";
import { IOrganisationState } from "./globalShared";
import { IOrganisation } from "../../../onboarding/onboardingModels";

const getUserList = (state: IOrganisationState) =>
    state.globalShared.userList

export const UserSelector = createSelector(
    [getUserList],
    (userList: IUserProfile) => userList,
);

 
const getOrgList = (state: IOrganisationState) =>
    state.globalShared.organisationList
 
export const OrgSelector = createSelector(
    [getOrgList],
    (organisationList: IOrganisation[]) => organisationList,
);

const getSelectedOrg = (state: IOrganisationState) =>
    state.globalShared.gatewaySelectedOrganisation

export const SelectedOrgSelector = createSelector(
    [getSelectedOrg],
    (selectedOrganisation: IOrganisation) => selectedOrganisation,
);

const getOrganizationModalValueType = (state: IOrganisationState) =>
    state.globalShared.organizationModalValue
export const selectedOrganizationModalValueSelector = createSelector(
    [getOrganizationModalValueType],
    (organizationModalValue: boolean) => organizationModalValue,
);

export const enableRolePrivilegesForSIOrgSelector = createSelector(
  (state: IOrganisationState) => state.globalShared,
  globalShared => globalShared.enableRolePrivilegesForSIOrg
);